export enum WorkflowsRoutes {
  root = 'workflows',
  view = 'view',
  create = 'create',
}
